import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';

import DxChart, {
    DxArgumentAxis,
    DxLegend,
    DxLabel,
    DxSeries,
    DxCommonSeriesSettings
} from 'devextreme-vue/chart';

export default {
    name: 'chart',
    components: {
        DxChart,
        DxArgumentAxis,
        DxLabel,
        DxLegend,
        DxSeries,
        DxCommonSeriesSettings
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        chart_data: {
            type: Array,
            required: true
        },
        arg_field: {
            type: String,
            required: true
        },
        value_field: {
            type: String,
            required: true
        },
        tick_interval: {
            type: Number,
            default: 10
        },
        chart_type: {
            type: String,
            default: 'bar'
        }
    },
    data: function () {
        return {
            
        }
    },
    created() {
        
    }
}

